import { useTranslation } from 'react-i18next';
import AppLayout from '../../../components/AppLayout';

const ClaimSubmitted = ({ createdId, workflowMsg, createdClaimNumber, history, setStep, setSubmitted, setFormData, S }) => {
  const { t } = useTranslation();
  return (
    <AppLayout>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', padding: 40 }}>
        <div style={{ textAlign: 'center', maxWidth: 480 }}>
          <div
            style={{
              width: 72,
              height: 72,
              borderRadius: 18,
              background: '#dcfce7',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto 24px',
            }}
          >
            <svg width='36' height='36' viewBox='0 0 24 24' fill='none' stroke='#15803d' strokeWidth='1.8' strokeLinecap='round' strokeLinejoin='round'>
              <path d='M22 11.08V12a10 10 0 1 1-5.93-9.14' />
              <polyline points='22 4 12 14.01 9 11.01' />
            </svg>
          </div>
          <div style={{ fontSize: 24, fontWeight: 700, color: S.textPrimary, marginBottom: 8 }}>{t('screens.claimsScreen.new.submittedTitle')}</div>
          <div style={{ fontSize: 14, color: S.textMuted, marginBottom: 8 }}>{t('screens.claimsScreen.new.submittedDesc', { id: createdClaimNumber })}</div>
          {workflowMsg && (
            <div
              style={{
                fontSize: 13,
                padding: '10px 16px',
                background: S.bgCard,
                border: `1px solid ${S.borderLight}`,
                borderRadius: 10,
                color: S.textSecondary,
                marginBottom: 28,
                display: 'inline-block',
              }}
            >
              {workflowMsg}
            </div>
          )}
          <div style={{ display: 'flex', gap: 10, justifyContent: 'center', marginTop: 24 }}>
            <button
              onClick={() => history.push(`/claims/${createdId}`)}
              style={{
                padding: '12px 24px',
                background: `linear-gradient(135deg, ${S.burgundy}, ${S.burgundy2})`,
                color: '#fff',
                border: 'none',
                borderRadius: 10,
                fontSize: 13,
                fontWeight: 600,
                cursor: 'pointer',
              }}
            >
              {t('screens.claimsScreen.new.viewClaim')}
            </button>
            <button
              onClick={() => {
                setStep(1);
                setSubmitted(false);
                setFormData({
                  claimantName: '',
                  company: '',
                  email: '',
                  phone: '',
                  policyNumber: '',
                  lineOfBusiness: '',
                  lossDate: '',
                  priority: 'medium',
                  reportedBy: 'claimant',
                  description: '',
                });
              }}
              style={{
                padding: '12px 24px',
                background: '#fff',
                border: `1px solid ${S.borderLight}`,
                borderRadius: 10,
                fontSize: 13,
                fontWeight: 600,
                color: S.textSecondary,
                cursor: 'pointer',
              }}
            >
              {t('screens.claimsScreen.new.createAnother')}
            </button>
            <button
              onClick={() => history.push('/claims')}
              style={{
                padding: '12px 24px',
                background: '#fff',
                border: `1px solid ${S.borderLight}`,
                borderRadius: 10,
                fontSize: 13,
                fontWeight: 600,
                color: S.textSecondary,
                cursor: 'pointer',
              }}
            >
              {t('screens.claimsScreen.new.backToClaims')}
            </button>
          </div>
        </div>
      </div>
    </AppLayout>
  );
};

export default ClaimSubmitted
